<template>
  <tr v-on:click="move(fintech.id)" class="fintech-table-body-row">
    <td class="fintech-table-body-col">
      {{ fintech.name_en }}({{ fintech.name_ja }})
    </td>
    <td class="fintech-table-body-col for-pc">
      <template v-if="current !== undefined && current !== null">
        <p>{{ service }}</p>
      </template>
      <template v-else>
        <p v-for="category in categories" :key="category.id">{{ category.name }}</p>
      </template>
    </td>
    <td class="fintech-table-body-col for-pc">{{ fintech.office_country }}</td>
    <td class="fintech-table-body-col">{{ establishedAt }}</td>
  </tr>
</template>

<script>
  const querystring = require('querystring')

  export default {
    props: [
      'fintech',
      'categories',
      'establishedAt',
      'service'
    ],

    data () {
      return {
        current: null
      }
    },

    methods: {
      move (id) {
        location.href = '/fintechs/' + id;
        return false;
      }
    },

    mounted () {
      if (location.search) {
        const search = location.search.replace('?', '')
        if (querystring.parse(search).category !== 'all') {
          this.current = querystring.parse(search).category
        }
      }
    }
  }
</script>